import { LanguageSpeakDatesAs, Option } from '@app/types';

const languageSpeakDatesAsLabels: Record<LanguageSpeakDatesAs, string> = {
  [LanguageSpeakDatesAs.dayMonthYear]: 'Day/Month/Year',
  [LanguageSpeakDatesAs.monthDayYear]: 'Month/Day/Year',
  [LanguageSpeakDatesAs.yearMonthDay]: 'Year/Month/Day'
};

export const languageSpeakDatesAsOptions: Option<LanguageSpeakDatesAs | null>[] = [
  { label: 'Unset', value: null },
  ...Object.values(LanguageSpeakDatesAs).map((value) => {
    return {
      label: languageSpeakDatesAsLabels[value],
      value
    };
  })
];
